import { TweenLite } from "gsap";
import { scroller } from "@/core/resource";
var Feature = /** @class */ (function () {
    function Feature() {
        console.log("[create] Feature");
    }
    Feature.prototype.setup = function () {
        this._featureTopics1Elem = document.getElementById("feature_topics1");
        this._featureTopics2Elem = document.getElementById("feature_topics2");
        this._featureTopics1SpElem = document.querySelector(".topics1_sp");
        this._featureTopics2SpElem = document.querySelector(".topics2_sp");
        this._featureBtnElem = document.getElementById("feature_btn");
        this._topics1Bnr = document.getElementById("topics1_bnr");
        this._topics2Bnr = document.getElementById("topics2_bnr");
        this._featureBtnLiElems = this._featureBtnElem.querySelectorAll("li");
        this._featureTopicsLine = document.querySelector(".topics1_line.topics2_line");
        this._isFirst = true;
        this._showTopic1();
        this._setNativeEvents();
    };
    Feature.prototype.teardown = function () { };
    Feature.prototype._setNativeEvents = function () {
        var _this = this;
        this._featureBtnLiElems[0].addEventListener("click", function () {
            if (_this._isFirst) {
                return;
            }
            _this._showTopic1();
        });
        this._featureBtnLiElems[1].addEventListener("click", function () {
            if (!_this._isFirst) {
                return;
            }
            _this._showTopic2();
        });
        this._topics1Bnr.addEventListener("click", function (e) {
            e.preventDefault();
            if (_this._isFirst) {
                return;
            }
            _this._showTopic1();
            scroller.scrollTop = 0;
        });
        this._topics2Bnr.addEventListener("click", function (e) {
            e.preventDefault();
            if (!_this._isFirst) {
                return;
            }
            _this._showTopic2();
            scroller.scrollTop = 0;
        });
    };
    Feature.prototype._showTopic1 = function () {
        this._featureBtnLiElems[0].classList.remove("btn_hidden");
        this._featureBtnLiElems[1].classList.add("btn_hidden");
        this._featureTopicsLine.classList.add("topics1_line");
        this._featureTopicsLine.classList.remove("topics2_line");
        TweenLite.set([this._featureTopics2Elem, this._featureTopics2SpElem], {
            display: "none",
        });
        TweenLite.set(this._featureTopics1SpElem, { clearProps: "display" });
        TweenLite.fromTo(this._featureTopics1Elem, 1, { autoAlpha: 0 }, { display: "block", autoAlpha: 1 });
        this._isFirst = true;
    };
    Feature.prototype._showTopic2 = function () {
        this._featureBtnLiElems[0].classList.add("btn_hidden");
        this._featureBtnLiElems[1].classList.remove("btn_hidden");
        this._featureTopicsLine.classList.add("topics2_line");
        this._featureTopicsLine.classList.remove("topics1_line");
        TweenLite.set([this._featureTopics1Elem, this._featureTopics1SpElem], {
            display: "none",
        });
        TweenLite.set(this._featureTopics2SpElem, { clearProps: "display" });
        TweenLite.fromTo(this._featureTopics2Elem, 1, { autoAlpha: 0 }, { display: "block", autoAlpha: 1 });
        this._isFirst = false;
    };
    return Feature;
}());
export default Feature;
